import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Select } from '@jisr-hr/design-system'
import { updateOvertime } from 'redux/actions/overtimeRequestActions'
import { hasPermission } from 'components/global/HelperFunctions'

import Styles from './RequestedOvertime.module.css'
import { useRequest } from '../../RequestProvider'

const options = [
  { label: 'x1.5', value: 1.5 },
  { label: 'x2', value: 2 },
]

const HourlyPopper = ({ details, reloadRequest }) => {
  const dispatch = useDispatch()
  const { actionCallback } = useRequest()
  const { employee } = useSelector(({ auth }) => auth)

  const [rate, setRate] = React.useState()
  const hourlyRate = options?.find((option) => option.value === rate)

  const canChangeRate =
    details?.status === 'pending' &&
    details?.can_take_action &&
    details?.overtime_policy === 2 &&
    hasPermission(employee, details?.employee?.id, employee?.permission_details?.view_attendance) &&
    employee?.permission_details?.send_attendance_requests_for_employees

  const handleChangeRate = (val) => {
    setRate(val?.value)
    dispatch(
      updateOvertime(details?.approval?.request_id, {
        employee_id: details.employee.id,
        overtime_request: {
          hour_rate: val?.value,
        },
      }),
    )
      .then(() => {
        reloadRequest()
        actionCallback(true)
      })
      .catch(() => {
        setRate(details?.hour_rate)
      })
  }

  React.useEffect(() => {
    setRate(details?.hour_rate)
  }, [details?.hour_rate])

  return (
    <Select
      className={Styles.hourlySelect}
      value={hourlyRate}
      options={options}
      onChange={handleChangeRate}
      disabled={!canChangeRate}
    />
  )
}

HourlyPopper.propTypes = {
  details: PropTypes.shape(),
  reloadRequest: PropTypes.func,
}

export default HourlyPopper
